module.exports = __webpack_public_path__ + "static/CBMPB-ea851e95b0b726c38293b9d834e772e4.png";